import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mfm'
})
export class MfmPipe implements PipeTransform {

  transform(value: any): unknown {
    let response = [];
    value.map(
      x=>{
        if (x.scale != 'MfM') response.push(x)
      }
    )
    return response;
  }

}
